export enum CookieKey {
    XAccessToken = 'X-Access-Token',
}
